import customAxios from './axios';
import CONFIG from '../../config';

export const getAll = () => {
    return customAxios.get(CONFIG.apiURL + '/ProcessCosts').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getIndividual = (id) => {
    return customAxios.get(CONFIG.apiURL + `/ProcessCosts/${id}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const create = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/ProcessCosts/Create', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const update = (payload) => {
    return customAxios.put(CONFIG.apiURL + '/ProcessCosts/Update', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getModuleTypeAndGroups = () => {
    return customAxios.get(CONFIG.apiURL + '/ProcessCosts/ModuleTypesAndGroups').then(res => {
        let response = res['data'];
        return response;
    });
};